import { render } from "./indexPriceTableComponent.vue?vue&type=template&id=6fe7656a&scoped=true"
import script from "./indexPriceTableComponent.vue?vue&type=script&lang=js"
export * from "./indexPriceTableComponent.vue?vue&type=script&lang=js"

import "./indexPriceTableComponent.vue?vue&type=style&index=0&id=6fe7656a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fe7656a"]])

export default __exports__